import { lazy } from 'react';
import { Routes } from '../../utils/constants';

const SectionsPage = lazy(() => import('../../pages/sections'));
const SectionPage = lazy(() => import('../../pages/sections/section'));
const ProgrammePage = lazy(() => import('../../pages/programme'));
const WatchPage = lazy(() => import('../../pages/watch'));
const ProfilePage = lazy(() => import('../../pages/profile'));
const CriticalThinkingQuizPage = lazy(
  () => import('../../pages/sections/sub-hq/critical-thinking-quiz'),
);
const NewHqPage = lazy(() => import('../../pages/sections/sub-hq'));
const StoryStopPage = lazy(
  () => import('../../pages/sections/sub-hq/story-stop'),
);
const StoryStopContentPage = lazy(
  () => import('../../pages/sections/sub-hq/story-stop/story-stop-content'),
);
const PledgePage = lazy(() => import('../../pages/sections/sub-hq/pledge'));

export const privateRoutes = [
  {
    name: 'SectionsPage',
    path: Routes.sections,
    component: SectionsPage,
  },
  {
    name: 'SectionPage',
    path: Routes.section(),
    component: SectionPage,
  },
  {
    name: 'ProgrammePage',
    path: Routes.programme(),
    component: ProgrammePage,
  },
  {
    name: 'WatchPage',
    path: Routes.watch(),
    component: WatchPage,
  },
  {
    name: 'ProfilePage',
    path: Routes.profile,
    component: ProfilePage,
  },

  // new hq
  {
    name: 'New HQ Menu',
    path: Routes.newHq(),
    component: NewHqPage,
  },
  {
    name: 'CriticalThinkingQuizPage',
    path: Routes.criticalThinkingQuiz(),
    component: CriticalThinkingQuizPage,
  },
  {
    name: 'StoryStopPage',
    path: Routes.storyStop(),
    component: StoryStopPage,
  },
  {
    name: 'StoryStopContentPage',
    path: Routes.storyStopContent(),
    component: StoryStopContentPage,
  },
  {
    name: 'PledgePage',
    path: Routes.pledge(),
    component: PledgePage,
  },
];
